"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var subscriptionsCount = 0;
var isDebugMode = typeof window !== 'undefined' && /debug$/m.test(window.location.hash);
var printSubscriptionsCount = isDebugMode
    ? // eslint-disable-next-line no-console
        function () { return console.debug('%c #', 'color: #40bbc6;', subscriptionsCount); }
    : function () { };
/**
 * Internal hook that manages subscriptions.
 */
function useRx(observable$, observer) {
    react_1.useEffect(function () {
        var subscription = observable$.subscribe(observer);
        subscriptionsCount++;
        printSubscriptionsCount();
        return function () {
            subscription.unsubscribe();
            subscriptionsCount--;
            printSubscriptionsCount();
        };
    }, [observable$]);
}
exports.useRx = useRx;
/**
 * React Debugger for RxJS observables.
 * Subscribes on observable changes and logs all changes in the console.
 *
 * @param observable$
 * @param tag
 */
function useRxDebug(observable$, tag) {
    useRx(observable$, {
        next: function (res) {
            if (isDebugMode) {
                // eslint-disable-next-line no-console
                console.debug('%c %s →', 'color: #40bbc6;', tag, res);
            }
        },
        error: function (e) {
            if (isDebugMode) {
                // eslint-disable-next-line no-console
                console.debug('%c %s →', 'color: red; font-weight: bold;', tag, e);
            }
        }
    });
}
exports.useRxDebug = useRxDebug;
//# sourceMappingURL=use-rx.js.map